import React, { useState } from 'react';
import { FaUser, FaUserPlus } from 'react-icons/fa';
import './resort-room-types.css';

import { useAppCtx } from './app-ctx';

/**
 * roomsData
 *   [
          {
            "room_id":4568,
            "resort_id":493,
            "name":"Double Comfort (with balcon)",
            "main":2,
            "extra":1,
            "room":4568,
            "boards":"010101",
            "price":"845.00",
            "avail":0
          }
      ],

  */

const renderPeopleIcons = (count, isExtra = false) => {
  const icons = [];
  const IconComponent = isExtra ? FaUserPlus : FaUser;
  const iconColor = isExtra ? "#7f8c8d" : "#2c3e50";
  
  for (let i = 0; i < count; i++) {
    icons.push(
      <IconComponent 
        key={i} 
        color={iconColor} 
        size={16} 
        style={{ marginRight: 5 }}
      />
    );
  }
  
  return icons.length ? icons : <span style={{ color: '#ccc' }}>—</span>;
};
                    
const RoomTypes = ({resortId, roomsData, occupacyValue, dietaryValue, dateRangeValue}) => {
    const {JOOMLA_VARS, CONFIG} = useAppCtx();

    const [rooms, setRooms] = useState(roomsData);
    const [prices, setPrices] = useState(null);

    React.useEffect(() => {
        const appRoot = JOOMLA_VARS.root;
        const apiPath = CONFIG.getPrices;

        const payload = {
                resort_id: resortId,
                occupacy:  occupacyValue,
                dietary:   dietaryValue,
                dates:     dateRangeValue
            };

        console.log('RoomTypes.useEffect(): payload:', JSON.stringify(payload));

        // Abort on unmount so a slow price response never hits an unmounted component
        const controller = new AbortController();

        fetch(appRoot + apiPath, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'X-CSRF-Token': JOOMLA_VARS.csrfToken || ''},
            //resortId, occupacyValue, dietaryValue, dateRangeValue
            body: JSON.stringify(payload),
            signal: controller.signal
        })
        .then(response => response.text())
        .then(text => {
            let data;
            try {
                data = JSON.parse(text);
            } catch (e) {
                console.error("RoomTypes: Failed to parse JSON. Response text:", text);
                return;
            }

            console.log('RoomTypes.useEffect(): data:', JSON.stringify(data)); 
            if (data.error) {
                console.log('RoomTypes.useEffect(): Server error:', data.error.message);
                return;
            }
            roomsData = data.prices.roomsWithPrices;
            // Sort function
            roomsData.sort((a, b) => {
              // First, compare avail: items with avail != 0 should come first
              const availA = a.avail !== 0 ? 0 : 1; // 0 = higher priority
              const availB = b.avail !== 0 ? 0 : 1;
              
              if (availA !== availB) {
                return availA - availB;
              }

              // If same group, sort by price ascending
              return parseFloat(a.price) - parseFloat(b.price);
            });

            setPrices( data.prices );
            setRooms( roomsData );
        })
        .catch(error => {
            // Ignore cancellations caused by cleanup (unmount / re-fetch)
            if (error && error.name === 'AbortError') return;
            console.log('RoomTypes.useEffect(): error:', error);
        });

        return () => controller.abort();
    }, []);

  return (
    <>
      <div className="room-types-container">
          {rooms.map((room) => (
            <div key={room.room_id} className={`room-card ${room.avail ? 'highlite' : ''}`}>
              {/*<a href={`/book//${room.room_id}`} className="room-id">{room.room_id}</a>*/}
              <span className="people-icons">
                  {renderPeopleIcons(room.main, false)}
                  {renderPeopleIcons(room.extra, true)}
              </span>
              <span className="room-name">{room.name}</span>
              {'price' in room && (
                <>
                  <span className='currency-symbol'>{prices.currencySymbol}</span>
                  <span className="price">{room.price}</span>
                  <span className='currency-code'>{prices.currency}</span>
                </>
              )}
            </div>
          ))}
      </div>
    </>
  );
};

export default RoomTypes;
